import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { MapStringTo, Nullable } from "../base-types";
import { MinimalSchema } from "../contracts/querying/minimal-schema";
import { ListResource } from "./list-resource";
import { SearchDocumentResource } from "./search-document-resource";

@JsonObject()
export class QueryResultResource extends ListResource<SearchDocumentResource> {
    @JsonProperty("scroll_id")
    scrollId?: Nullable<string>;

    @JsonProperty("items")
    @JsonElementType(SearchDocumentResource)
    items: Array<SearchDocumentResource>;

    @JsonProperty("minimal_schema_list")
    minimalSchemaList?: MapStringTo<MinimalSchema>;
}
